<div class="filter-container"
     role="dialog"
     aria-modal="true"
     aria-labelledby="contracts-filter-title"
     (keydown.escape)="close()"
     (keydown.tab)="trapFocus($any($event))"
     (keydown.shift.tab)="trapFocus($any($event))">
    <div class="filter-close">
        <button type="button" class="filter-close-btn" aria-label="Close filters" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
        <h2 id="contracts-filter-title" class="h4 mb-0 fw-bolder">Filters</h2>
    </div>

    <hr />

    <form [formGroup]="form" (submit)="applyFilter()">
        <div class="mb-3">
            <label for="contracts-filter-title-input" class="form-label fw-semibold">Title</label>
            <input #firstField id="contracts-filter-title-input" type="text" class="form-control"
                   formControlName="title" autocomplete="off" />
        </div>

        <div class="mb-3">
            <label for="contracts-filter-code" class="form-label fw-semibold">Code</label>
            <input id="contracts-filter-code" type="text" class="form-control"
                   formControlName="code" autocomplete="off" />
        </div>

        <div class="mb-3">
            <label for="contracts-filter-service-provider" class="form-label fw-semibold">Service provider</label>
            <input id="contracts-filter-service-provider" type="text" class="form-control"
                   formControlName="serviceProvider" autocomplete="off" />
        </div>

        @if (canSeeInactive) {
            <div class="form-check mb-2">
                <input id="contracts-filter-show-deactivated" type="checkbox" class="form-check-input"
                       formControlName="showDeactivated" />
                <label for="contracts-filter-show-deactivated" class="form-check-label">Show deactivated contracts</label>
            </div>
            <div class="form-check mb-3">
                <input id="contracts-filter-show-deleted" type="checkbox" class="form-check-input"
                       formControlName="showDeleted" />
                <label for="contracts-filter-show-deleted" class="form-check-label">Show deleted contracts</label>
            </div>
        }

        <hr />

        <div class="d-grid gap-2 mt-4">
            <button type="button" class="btn btn-gray text-dark rounded-pill fw-bold" (click)="reset()">
                Reset filters
            </button>
            <button type="submit" class="btn btn-success rounded-pill fw-bold">
                Apply filters
            </button>
        </div>
    </form>
</div>
